import { TFunction } from 'i18next';

import { ROLE_ENUM_TO_LABEL_MAP } from '../../Shared/constants/userRoles';
import { getFormattedDate } from '../../Shared/utils/helpers';
import {
  PERMISSION_TRANSLATION_MAP,
  ROLE_MANAGEMENT_COLUMN_KEYS,
} from '../constants/permissionConstants';

export const formatCellValue = (
  key: string,
  value: unknown,
  t: TFunction
): string => {
  if (Array.isArray(value) && typeof value[0] === 'string') {
    return value.map((perm) => t(PERMISSION_TRANSLATION_MAP[perm])).join(', ');
  }
  if (value === null || value === undefined) return '-';
  if (key === ROLE_MANAGEMENT_COLUMN_KEYS.USERROLE) {
    return t(
      ROLE_ENUM_TO_LABEL_MAP.find((option) => option.role === (value as string))
        ?.label ?? 'user-role-form-label'
    );
  }
  if (
    (key === ROLE_MANAGEMENT_COLUMN_KEYS.CREATEDAT ||
      key === ROLE_MANAGEMENT_COLUMN_KEYS.LASTUPDATEDAT) &&
    typeof value === 'number'
  ) {
    return getFormattedDate(value);
  }
  return String(value);
};
